<template>
  <el-container :class="[($route.name === 'tutoralsVideos')? 'background-videos' : '' ,'PageContainer']">
    <el-header
      class="PageContainer-header"
      :height="browserContext.up('xl') ? '128px' : 'auto'"
    >
      <div class="responsive-main">
        <page-header>
          <slot name="page-actions"></slot>
        </page-header>
        <slot name="page-tabs"></slot>
      </div>
    </el-header>
    <el-main class="PageContainer-main">
      <div class="responsive-main">
        <slot></slot>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import PageHeader from './PageHeader.vue'

/**
 * Conteneur de page
 */
export default {
  name: 'UbiPageContainer',
  inject: ['browserContext'],
  components: {
    PageHeader
  }
}
</script>

<style lang="scss">
@import "@/theme/_bootstrap.scss";

.background-videos{
  min-height: 780px;
  background-image: url("../assets/fond-pour-EC-tuto-72dpi.png");
  background-position: center;
  background-size: 70%;
}

.PageContainer {
  position: relative;
  width: 100%;
  &-header {
    @extend .p-0;
    align-items: center;
    background-image: url("~@/assets/header_tablette.jpg");
    @include image-retina("~@/assets/header_tablette@2x.jpg", 1300px, 250px);
    background-repeat: no-repeat;

    position: sticky;
    top: 50px;
    left: 0;
    right: 0;
    z-index: 999;
    display: flex;
    justify-content: center;
    overflow: hidden;

    .responsive-main {
      display: flex;
      flex-direction: column;
      height: 100%;
      justify-content: space-between;
      min-height: 128px;
    }
  }

  .el-tabs {
    &__nav-prev,
    &__nav-next {
      color: $white;
      font-size: 16px;
      text-align: center;
      width: map-get($spacers, 4);
    }
    &__nav-wrap {
      @extend .px-4;
    }
  }

  &-main {
    @extend .px-0, .pt-5, .pb-0;
  }

  @include media-breakpoint-up(md) {
    &-header {
      background-position: -50px -50px;
    }
  }

  @include media-breakpoint-up(xl) {
    &-header {
      background-image: url("~@/assets/header.png");
      @include image-retina("~@/assets/header@2x.png", 2304px, 194px);
      background-position: -316px -50px;
      min-height: 128px;
    }
  }

  @include media-breakpoint-down(sm) {
    &-header {
      background-position: -50 -50;
      background-repeat: no-repeat;
      left: 0;
      position: sticky;
      right: 0;
      top: 0;
      z-index: 1099;
      min-height: 0;

      .responsive-main {
        width: 100%;
        min-height: 0;
      }
    }

    &-main {
      padding: map-get($spacers, 3) !important;
    }

    .el-tabs {
      &__nav-prev,
      &__nav-next {
        line-height: 32px;
      }
    }
  }
}
</style>
